import { initializeApp } from "firebase/app";
import {getFirestore} from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyA_Xm85HZEeR0gxadmrtEXaz-vT3rLrzHc",
  authDomain: "grihapravesh-cef51.firebaseapp.com",
  projectId: "grihapravesh-cef51",
  storageBucket: "grihapravesh-cef51.appspot.com",
  messagingSenderId: "830290842293",
  appId: "1:830290842293:web:d5d147bbec55b59a49a4fc"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(); 